import React from 'react';
import { Typography } from '@material-ui/core';
import PrincipleHeaderImage from 'views/Principles/HeaderImage';
import HeaderContainer from './HeaderContainer';
import HeroContainerMobile from './HeroContainer/mobile';
//TODO: change once we have all images
const GuideHeader = ({ name, text, cdnId = 'app_images/spirit-wide-arms' }) => {
  return (
    <HeaderContainer height={420}>
      <PrincipleHeaderImage cdnId={cdnId} />
      <HeroContainerMobile width={600}>
        <Typography variant="h4" gutterBottom>
          {name}
        </Typography>
        <Typography variant="body1" align="center">
          {text}
        </Typography>
      </HeroContainerMobile>
    </HeaderContainer>
  );
};

export default GuideHeader;
